import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export type ToggleOption = 'option1' | 'option2';

export interface IToggleItem {
  value: string;
  labelPath: string;
  count?: string;
  icon?: string;
}

@Component({
  selector: 'app-option-toggle',
  templateUrl: './option-toggle.component.html',
  styleUrls: ['./option-toggle.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionToggleComponent {
  // Legacy 2-option API
  public readonly selectedOption = input<ToggleOption>('option1');
  public readonly option1Text = input<string>('Option 1');
  public readonly option2Text = input<string>('Option 2');
  public readonly option1Icon = input<string>('circle');
  public readonly option2Icon = input<string>('square');
  public readonly optionChange = output<ToggleOption>();

  // Generic N-option API
  public readonly options = input<IToggleItem[]>([]);
  public readonly selectedValue = input<string>('');
  public readonly valueChange = output<string>();

  public setToggle(option: ToggleOption): void {
    this.optionChange.emit(option);
  }

  public setValue(value: string): void {
    this.valueChange.emit(value);
  }
}
